// Define the window interface to include dataLayer
declare global {
  interface Window {
    dataLayer: any[];
  }
}

// Initialize dataLayer if it doesn't exist
if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
}

/**
 * Track a custom event in Google Tag Manager
 * @param eventName The name of the event to track
 * @param eventData Additional data to track with the event
 */
export const trackEvent = (eventName: string, eventData: Record<string, any> = {}) => {
  if (typeof window !== 'undefined') {
    window.dataLayer.push({
      event: eventName,
      ...eventData,
    });
  }
};

// Predefined event tracking functions
export const analytics = {
  // Track page view
  trackPageView: (pageName: string) => {
    trackEvent('Page View', { page_name: pageName });
  },
  
  // Track when verification code is sent
  trackSendCode: (email: string) => {
    trackEvent('Send Code', { email });
  },
  
  // Track when a platform is selected
  trackPlatformSelect: (platform: string) => {
    trackEvent('Platform Select', { platform });
  },
  
  // Track form submission
  trackSubmit: (formName: string, data: Record<string, any> = {}) => {
    trackEvent('Submit', { form_name: formName, ...data });
  },
  
  // Track marketplace creation
  trackCreate: (marketplaceData: Record<string, any> = {}) => {
    trackEvent('Create', marketplaceData);
  },
  
  // Track "Make it Mine" action
  trackMakeItMine: (marketplaceId: string) => {
    trackEvent('Make it Mine', { marketplace_id: marketplaceId });
  },
}; 